import React from "react";
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import { isIPhone } from "@/modules/iOSDetection";
import { mouseOver, mouseLeave } from "@/modules/mouseInteractions";
import { twelveDReds } from "@/modules/commonMobile";

import "./index.scss";
import { IGameTableType } from "@/types/GlobalTypes";
import zeroFill from "@/modules/zeroFill";

import PortraitP9 from "./Portrait";

//12D
export default class P9 extends React.PureComponent<IGameTableType> {
	state = { activeHover: "" };

	render() {
		const { langdata } = this.props;
		
		const win = this.props.win ? Number(this.props.win) : null;
		const winStr = win ? zeroFill(win, 2) : null;

		// console.log("p9 win", win);

		const isJackpot = win && win === 20;
		const allowWin = win && !isJackpot;

		const activeHover = this.state.activeHover;

		const pcodeProp = { pcode: this.props.pcode };

		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		};

		const commonTooltipProps = {
			langStr: langdata.language_code
		};

		if (this.props.portrait)
			return <PortraitP9 {...this.props} />;

		return (
			<div className="sl-table p9">
				<div className="p9-square">
					<div className={"sl-bet sl-green-old" + (allowWin && (win <= 6 && win > 0) ? " sl-yellow-alternating" : "")}>
						<div className={this.props.maximised ? "p9-text-smaller" : ""}>{this.props.langdata["txt_small"]}</div>
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey="Small+n50" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["Small+n50"]} />
						<div className="sl-hover-hidden"
							{...{
								bet: "Small",
								group: "n50",
								...pcodeProp
							}}
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>

					<div className={"sl-bet sl-green-old" + (allowWin && (win % 2) ? " sl-yellow-alternating" : "")}>
						<div className={this.props.maximised ? "p9-text-smaller" : ""}>{this.props.langdata["txt_odd"]}</div>
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey="Odd+n50" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["Odd+n50"]} />
						<div className="sl-hover-hidden"
							{...{
								bet: "Odd",
								group: "n50",
								...pcodeProp
							}}
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>

					<div className={"sl-bet sl-green-old" + (allowWin && (twelveDReds.indexOf(Number(win)) >= 0) ? " sl-yellow-alternating" : "")}>
						<div className="sl-red-lighten p9-diamond" />
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey="Red+n50" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["Red+n50"]} />
						<div className="sl-hover-hidden"
							{...{
								bet: "Red",
								group: "n50",
								...pcodeProp
							}}
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
				</div>

				<div className={"sl-bet p9-rectangle-jackpot sl-green-lighten" + (isJackpot ? " sl-yellow-alternating" : "")}
					{...{
						bet: "Jackpot",
						group: "jackpot",
						...pcodeProp
					}}
					onClick={this.props.insertBet}>
					<div>
						{this.props.maximised ? <div>Jackpot</div> : <div className="p9-text">JACKPOT</div>}
						<div className="bet-type">1:44</div>
						<Chips {...commonChipProps} betKey="Jackpot+jackpot" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["Jackpot+jackpot"]} />
					</div>
				</div>

				{
					"rbrb".split("").map((group, colIdx) => {
						const nth = (colIdx + 1) + (colIdx === 0 ? "st" : colIdx === 1 ? "nd" : colIdx === 2 ? "rd" : "th");
						const groupComma = "123".split("").map(item => {
							const num = Number(item) + colIdx * 3;
							return (num < 10 ? "0" : "") + num;
						}).join(",");

						return (
							<div key={groupComma} className="p9-rectangle">
								<div className={"sl-bet sl-green-old" + (allowWin && (groupComma.indexOf(winStr) >= 0) ? " sl-yellow-alternating" : "")}>
									<div className="p9-text-smaller"
										dangerouslySetInnerHTML={{ __html: this.props.langdata["txt_" + nth + "_line"] }}></div>

									<div className="bet-type">1:2.6</div>
									<Chips {...commonChipProps} betKey={groupComma + "+n3"} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n3"]} />
									<div className="sl-hover-hidden"
										{...{
											bet: groupComma,
											group: "n3",
											...pcodeProp
										}}
										onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
								</div>
								{
									"123".split("").map((_num) => {
										const num = colIdx * 3 + Number(_num);
										const betKey = ((num < 10) ? "0" : "") + num;

										let styles = "";

										if ((activeHover.indexOf(betKey) >= 0) ||
											(activeHover === "Red" && group === "r") ||
											(activeHover === "Black" && group === "b") ||
											(activeHover === "Even" && !(num % 2)) ||
											(activeHover === "Odd" && num % 2) ||
											(activeHover === "Small" && num <= 6) ||
											(activeHover === "Big" && num > 6))
											styles = " sl-bet-hover";

										if (winStr === betKey)
											styles += " sl-yellow-alternating";

										return (
											<div key={"p9_" + group + "_" + colIdx + "_" + betKey} className={"sl-bet" + (group === "r" ? " sl-red-lighten" : " sl-black-lighten") + styles}
												{...{
													bet: betKey,
													group: "n",
													...pcodeProp
												}}
												onClick={this.props.insertBet}>

												<div className="p9-text">{num}</div>
												<div className="bet-type">1:10</div>
												<Chips {...commonChipProps} betKey={betKey + "+n"} />
												<Tooltip {...commonTooltipProps} bet={this.props.bets[betKey + "+n"]} />
											</div>
										);
									})
								}
							</div>
						);
					})
				}

				<div className="p9-rectangle">
					<div className={"sl-bet sl-green-old" + (allowWin && (win % 3 === 1) ? " sl-yellow-alternating" : "")}>
						<div className="p9-text-smaller"
							dangerouslySetInnerHTML={{ __html: this.props.langdata["txt_1st_row"] }}></div>

						<div className="bet-type">1:1.75</div>
						<Chips {...commonChipProps} betKey="01,04,07,10+n4" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["01,04,07,10+n4"]} />
						<div className="sl-hover-hidden"
							{...{
								bet: "01,04,07,10",
								group: "n4",
								...pcodeProp
							}}
							// bet="01,04,07,10" pcode={this.props.pcode} group="n4"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
					<div className={"sl-bet sl-green-old" + (allowWin && (win % 3 === 2) ? " sl-yellow-alternating" : "")}>
						<div className="p9-text-smaller"
							dangerouslySetInnerHTML={{ __html: this.props.langdata["txt_2nd_row"] }}></div>
						{/*  this.props.maximised ? <div>2nd Line</div> : <div className="p9-text-smaller">2nd <br/>LINE</div>  */}

						<div className="bet-type">1:1.75</div>
						<Chips {...commonChipProps} betKey="02,05,08,11+n4" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["02,05,08,11+n4"]} />
						<div className="sl-hover-hidden"
							{...{
								bet: "02,05,08,11",
								group: "n4",
								...pcodeProp
							}}
							// bet="02,05,08,11" pcode={this.props.pcode} group="n4"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
					<div className={"sl-bet sl-green-old" + (allowWin && (win % 3 === 0) ? " sl-yellow-alternating" : "")}>
						<div className="p9-text-smaller"
							dangerouslySetInnerHTML={{ __html: this.props.langdata["txt_3rd_row"] }}></div>
						{/*  this.props.maximised ? <div>3rd Line</div> : <div className="p9-text-smaller">3rd <br/>LINE</div>  */}

						<div className="bet-type">1:1.75</div>
						<Chips {...commonChipProps} betKey="03,06,09,12+n4" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["03,06,09,12+n4"]} />
						<div className="sl-hover-hidden"
							{...{
								bet: "03,06,09,12",
								group: "n4",
								...pcodeProp
							}}
							// bet="03,06,09,12" pcode={this.props.pcode} group="n4"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
				</div>
				<div className="p9-square-right">
					<div className={"sl-bet  sl-green-old" + (allowWin && (win >= 7) ? " sl-yellow-alternating" : "")}>
						<div className={this.props.maximised ? "p9-text-smaller" : ""}>{this.props.langdata["txt_big"]}</div>
						{/*  this.props.maximised ? <div>Big</div> : <div className="p9-text-smaller">BIG</div>  */}
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey="Big+n50" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["Big+n50"]} />
						<div className="sl-hover-hidden"
							{...{
								bet: "Big",
								group: "n50",
								...pcodeProp
							}}
							// bet="Big" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
					<div className={"sl-bet sl-green-old" + (allowWin && !(win % 2) ? " sl-yellow-alternating" : "")}>
						<div className={this.props.maximised ? "p9-text-smaller" : ""}>{this.props.langdata["txt_even"]}</div>
						{/*  this.props.maximised ? <div>Even</div> : <div className="p9-text-smaller">EVEN</div>  */}
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey="Even+n50" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["Even+n50"]} />
						<div className="sl-hover-hidden"
							{...{
								bet: "Even",
								group: "n50",
								...pcodeProp
							}}
							// bet="Even" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
					<div className={"sl-bet sl-green-old" + (allowWin && (twelveDReds.indexOf(Number(win)) < 0) ? " sl-yellow-alternating" : "")}>
						<div className="sl-black-lighten p9-diamond" />
						<div className="bet-type">1:0.95</div>
						<Chips {...commonChipProps} betKey="Black+n50" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["Black+n50"]} />
						<div className="sl-hover-hidden"
							{...{
								bet: "Black",
								group: "n50",
								...pcodeProp
							}}
							// bet="Black" pcode={this.props.pcode} group="n50"
							onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
					</div>
				</div>


				{/*Multibet starts here*/}
				{
					[["01,04", "04,07", "07,10"],
					["02,05", "05,08", "08,11"],
					["03,06", "06,09", "09,12"]].map((row, rowIdx) =>
						row.map((groupComma, groupIdx) => {
							const firstPercent = this.props.maximised ? 36.4 : 31;
							const leftSpace = this.props.maximised ? 150 : 50;
							const width = this.props.maximised ? "32px" : "30px";

							return <div key={"p9_n2_1_" + rowIdx + "_" + groupIdx}
								className={"sl-bet hidden sl-green-old"}
								style={{
									position: "absolute",
									left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
									top: "calc(28% + " + (rowIdx * 50) + "px)",
									background: "transparent",
									width: width,
									height: "32px"
								}}>
								<Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
								<div className="sl-hover-hidden"
									{...{
										bet: groupComma,
										group: "n2",
										...pcodeProp
									}}
									// bet={groupComma} pcode={this.props.pcode} group="n2"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>;
						})
					)
				}

				{
					[["01,02", "04,05", "07,08", "10,11"],
					["02,03", "05,06", "08,09", "11,12"]].map((row, rowIdx) =>
						row.map((groupComma, groupIdx) => {
							const firstPercent = this.props.maximised ? 26 : 22;
							const leftSpace = this.props.maximised ? 150 : 50;
							const width = this.props.maximised ? "120px" : "40px";

							return <div key={"p9_n2_2_" + rowIdx + "_" + groupIdx}
								className={"sl-bet hidden sl-green-old"}
								style={{
									position: "absolute",
									left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
									top: "calc(42% + " + (rowIdx * 50) + "px)",
									background: "transparent",
									width: width,
									height: "32px"
								}}>
								<Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
								<div className="sl-hover-hidden"
									{...{
										bet: groupComma,
										group: "n2",
										...pcodeProp
									}}
									// bet={groupComma} pcode={this.props.pcode} group="n2"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>;
						})
					)
				}

				{
					[["01,02,04,05", "04,05,07,08", "07,08,10,11"],
					["02,03,05,06", "05,06,08,09", "08,09,11,12"]].map((row, rowIdx) =>
						row.map((groupComma, groupIdx) => {
							const firstPercent = this.props.maximised ? 36.4 : 31;
							const leftSpace = this.props.maximised ? 150 : 50;
							const width = this.props.maximised ? "32px" : "30px";

							return <div key={"p9_n4_3_" + rowIdx + "_" + groupIdx}
								className={"sl-bet hidden sl-green-old"}
								style={{
									position: "absolute",
									left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "px)",
									top: "calc(42% + " + (rowIdx * 50) + "px)",
									background: "transparent",
									width: width,
									height: "32px"
								}}>
								<Chips between={true} {...commonChipProps} betKey={groupComma + "+n4"} />
								<Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n4"]} />
								<div className="sl-hover-hidden"
									{...{
										bet: groupComma,
										group: "n4",
										...pcodeProp
									}}
									// bet={groupComma} pcode={this.props.pcode} group="n4"
									onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
							</div>;
						})
					)
				}
			</div>
		);
	}
}
